import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../src/firebaseConfig';
import './SellerOptions.css';
import logo from '../assets/logo.png';

const platforms = [
  { name: 'Disney+', color: '#113CCF', route: '/disney-panel' },
  //{ name: 'Spotify', color: '#1DB954', route: '/spotify-panel' },
  { name: 'Prime Video', color: '#00A8E1', route: '/prime-panel' }
];

const PlatformMenu = () => {
  const navigate = useNavigate();
  const [vendor, setVendor] = useState(null);

  useEffect(() => {
    const loadVendorData = async () => {
      const phone = sessionStorage.getItem('vendorPhone');
      if (!phone) {
        navigate('/code-login');
        return;
      }
      const q = query(collection(db, 'Vendedores'), where('phoneNumber', '==', phone));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const data = snapshot.docs[0].data();
        delete data.password;
        setVendor(data);
      } else {
        sessionStorage.removeItem('vendorPhone');
        navigate('/code-login');
      }
    };

    loadVendorData();
  }, [navigate]);

  const handlePlatformClick = (route) => {
    navigate(route);
  };

  return (
    <div className="seller-options">
      <img src={logo} alt="Logo de BearMax" className="company-logo" />
      <h1 className="title">Menú de Plataformas</h1>
      <p className="subtitle">
        {vendor ? (
          <>Bienvenido, <strong>{vendor.phoneNumber}</strong></>
        ) : (
          <>Cargando información del vendedor...</>
        )}
      </p>

      <div className="options-container">
        {platforms.map((platform) => (
          <div
            key={platform.name}
            className="option-card"
            style={{ borderColor: platform.color }}
            onClick={() => handlePlatformClick(platform.route)}
          >
            <div className="icon" style={{ backgroundColor: platform.color }}>
              {platform.name[0]}
            </div>
            <h3>{platform.name}</h3>
            <p>Consultar códigos de acceso de tus suscripciones activas</p>
            <button className="btn">Ingresar</button>
          </div>
        ))}
      </div>

      <div className="options-container">
        <button className="go-back-btn" onClick={() => navigate(-1)}>← Volver</button>
      </div>
    </div>
  );
};

export default PlatformMenu;
